/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MongoConnectionInfo
 */
export interface MongoConnectionInfo {
    /**
     * 
     * @type {string}
     * @memberof MongoConnectionInfo
     */
    host: string;
    /**
     * 
     * @type {number}
     * @memberof MongoConnectionInfo
     */
    connectionId: number;
    /**
     * 
     * @type {string}
     * @memberof MongoConnectionInfo
     */
    databaseName: string;
    /**
     * 
     * @type {number}
     * @memberof MongoConnectionInfo
     */
    port: number;
    /**
     * 
     * @type {string}
     * @memberof MongoConnectionInfo
     */
    readyState: MongoConnectionInfoReadyStateEnum;
}


/**
 * @export
 */
export const MongoConnectionInfoReadyStateEnum = {
    disconnected: 'disconnected',
    connected: 'connected',
    connecting: 'connecting',
    disconnecting: 'disconnecting',
    unknown: 'unknown'
} as const;
export type MongoConnectionInfoReadyStateEnum = typeof MongoConnectionInfoReadyStateEnum[keyof typeof MongoConnectionInfoReadyStateEnum];


/**
 * Check if a given object implements the MongoConnectionInfo interface.
 */
export function instanceOfMongoConnectionInfo(value: object): value is MongoConnectionInfo {
    if (!('host' in value) || value['host'] === undefined) return false;
    if (!('connectionId' in value) || value['connectionId'] === undefined) return false;
    if (!('databaseName' in value) || value['databaseName'] === undefined) return false;
    if (!('port' in value) || value['port'] === undefined) return false;
    if (!('readyState' in value) || value['readyState'] === undefined) return false;
    return true;
}

export function MongoConnectionInfoFromJSON(json: any): MongoConnectionInfo {
    return MongoConnectionInfoFromJSONTyped(json, false);
}

export function MongoConnectionInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MongoConnectionInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'host': json['host'],
        'connectionId': json['connectionId'],
        'databaseName': json['databaseName'],
        'port': json['port'],
        'readyState': json['readyState'],
    };
}

export function MongoConnectionInfoToJSON(json: any): MongoConnectionInfo {
    return MongoConnectionInfoToJSONTyped(json, false);
}

export function MongoConnectionInfoToJSONTyped(value?: MongoConnectionInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'host': value['host'],
        'connectionId': value['connectionId'],
        'databaseName': value['databaseName'],
        'port': value['port'],
        'readyState': value['readyState'],
    };
}

